import { TemplateElement, html, defineElement, when } from '@webtides/element-js';
import style from './card-tag.css';
import '../tag/tag.js';
import '../icon/icon.js';

/**
 * @property {string} name
 * @property {string} icon
 * @property {string} label
 * @property {boolean} selected
 */
export default class CardTag extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            name: '',
            icon: '',
            label: '',
            selected: false,
        };
    }

    template() {
        return html`
            <mb-tag name="${this.name}" variant="card" selected="${this.selected}" read-only="${this.selected}">
                <div class=" flex items-center gap-16">
                    ${when(this.icon, html` <mb-icon name="${this.icon}" size="48"></mb-icon> `)}
                    ${when(this.label, html` <div class="text-base md:text-xl mb-0">${this.label}</div> `)}
                </div>
            </mb-tag>
        `;
    }
}

defineElement('mb-card-tag', CardTag);
